import React, { useEffect, useState } from 'react'
import { createRoot } from 'react-dom/client'

import JobApplicationButton from './JobApplicationButton'
import { SessionContext } from '../profile_sheets/information_disclosures/application'
import { fetchSessionOnce } from './fetchSessionOnce'

const JobApplicationButtonForSlim = (props) => {
  const [session, setSession] = useState(null)

  useEffect(() => {
    void fetchSessionOnce()
      .then(json => setSession(json))
      .catch((error) => {
        // セッション取得失敗時は未ログイン相当で描画を継続する
        console.error('Failed to fetch session for JobApplicationButton', error)
      })
  }, [])

  return (
    <SessionContext.Provider value={session}>
      <JobApplicationButton {...props} />
    </SessionContext.Provider>
  )
}

window.addEventListener('DOMContentLoaded', () => {
  if (!document.querySelector('body.controller--job_offers')) return false
  if (!document.querySelector('body.action--show')) return false

  // for action--show
  const dom = document.querySelector('[data-react-job-application-button]')
  if (dom) {
    const props = JSON.parse(dom.dataset.reactJobApplicationButton)
    const root = createRoot(dom)

    const handleButtonContainerMount = (button_container) => {
      if (button_container) {
        const doc = document.documentElement
        const job_id = document.getElementById('job_id')

        if (job_id) {
          window.addEventListener('scroll', () => {
            if (doc.clientHeight >= job_id.getBoundingClientRect().bottom) {
              button_container.classList.remove('job-offer-application-button-container-fixed')
            } else if (doc.clientHeight < job_id.getBoundingClientRect().bottom) {
              button_container.classList.add('job-offer-application-button-container-fixed')
            }
          })
        }
      }
    }

    root.render(
      <JobApplicationButtonForSlim
        jobOfferId={props.job_offer_id}
        jobOfferTitle={props.job_offer_title}
        jobOfferOpen={props.job_offer_open}
        onButtonContainerMount={handleButtonContainerMount}
      />
    )
  }
})
